import * as search from './search'
import * as urls from './urls'
import * as dates from './dates'

/**
 *
 * @param {string|File} data
 * @returns
 */
async function sha256(data) {
  const buffer = typeof data === 'string' ? new TextEncoder().encode(data) : await data.arrayBuffer()

  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer)
  return [...new Uint8Array(hashBuffer)].map((b) => b.toString(16).padStart(2, '0')).join('')
}

export default { search, urls, dates, sha256 }
